/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Swap_Offline_BodyInputs */

const en_us2_workout_swap_offline_body = /** @type {(inputs: Workout_Swap_Offline_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This exercise's alternatives haven't been downloaded yet. Connect to see the options.`)
};

const pt_br2_workout_swap_offline_body = /** @type {(inputs: Workout_Swap_Offline_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As alternativas deste exercício ainda não foram baixadas. Conecte-se para ver as opções.`)
};

const es_419_workout_swap_offline_body = /** @type {(inputs: Workout_Swap_Offline_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las alternativas de este ejercicio todavía no se descargaron. Conéctate para ver las opciones.`)
};

const pt_pt2_workout_swap_offline_body = /** @type {(inputs: Workout_Swap_Offline_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As alternativas deste exercício ainda não foram transferidas. Liga-te à internet para ver as opções.`)
};

const fr_fr2_workout_swap_offline_body = /** @type {(inputs: Workout_Swap_Offline_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les alternatives de cet exercice n'ont pas encore été téléchargées. Connecte-toi pour voir les options.`)
};

const de_de2_workout_swap_offline_body = /** @type {(inputs: Workout_Swap_Offline_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Alternativen zu dieser Übung sind noch nicht heruntergeladen. Verbinde dich, um die Optionen zu sehen.`)
};

const it_it2_workout_swap_offline_body = /** @type {(inputs: Workout_Swap_Offline_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le alternative di questo esercizio non sono ancora state scaricate. Connettiti per vedere le opzioni.`)
};

/**
* | output |
* | --- |
* | "This exercise's alternatives haven't been downloaded yet. Connect to see the options." |
*
* @param {Workout_Swap_Offline_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_swap_offline_body = /** @type {((inputs?: Workout_Swap_Offline_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Swap_Offline_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_swap_offline_body(inputs)
	if (locale === "es-419") return es_419_workout_swap_offline_body(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_swap_offline_body(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_swap_offline_body(inputs)
	if (locale === "de-DE") return de_de2_workout_swap_offline_body(inputs)
	if (locale === "it-IT") return it_it2_workout_swap_offline_body(inputs)
	return en_us2_workout_swap_offline_body(inputs)
});
export { workout_swap_offline_body as "workout-swap.offline_body" }